export const globalWorkoutNormalType = 1;
export const globalWorkoutCircuitType = 2;
export const globalWorkoutSteadyStateCardio = 3;
export const globalTypeWorkoutCompoundSet = 4;
export const globalTypeWorkoutSuperSet = 5;
export const globalWorkoutCustomCardioRepeat = 6; //repeats exercises till total time
export const globalWorkoutWarmUpType = 7;
export const globalWorkoutCoolDownType = 8;

//Stretching
export const globalUpperBody = "Upper Body";
export const globalLowerBody = "Lower Body";
export const globalLowImpactCardio = "Low Impact Cardio";

//MuscleGroups
export const globalChest = "Chest";
export const globalBack = "Back";
export const globalTraps = "Traps";
export const globalShoulders = "Shoulders";
export const globalTriceps = "Triceps";
export const globalBiceps = "Biceps";
export const globalForearms = "Forearms";
export const globalLegs = "Legs";
export const globalCalves = "Calves";
export const globalGlutes_Hips = "Glutes/Hips";
export const globalLowerAbs = "Lower Abs";
export const globalMiddleAbs = "Middle Abs";
export const globalUpperAbs = "Upper Abs";
export const globalObliques = "Obliques";
export const globalCardio = "Cardio";

export const globalMuscleGroupsArray = [globalChest,globalBack,globalTraps,globalShoulders,globalTriceps,globalBiceps,globalForearms,globalLegs,globalCalves,globalGlutes_Hips,globalLowerAbs,globalMiddleAbs,globalUpperAbs,globalObliques,globalCardio,globalUpperBody,globalLowerBody,globalLowImpactCardio];
export const globalExerciseFilterMGArray = ["All", "Warm Ups", globalChest,globalBack,globalTraps,globalShoulders,globalTriceps,globalBiceps,globalForearms,globalLegs,globalCalves,globalGlutes_Hips,globalLowerAbs,globalMiddleAbs,globalUpperAbs,globalObliques,globalCardio, "Cool Downs"];
export const globalExerciseFilterEquipmentsArray = ["All", "Bodyweight","Dumbbell","Barbell","Resistance Band","Kettlebell","Cable","Medicine Ball","Machine"];

export const globalExerciseTypeWarmUp = 1;
export const globalExerciseTypeCoolDown = 2;


export const globalNewProgramID = "0";

export const globalBranchLiveKey = "key_live_ffC9wjTzzHauEL6XcJuoubfpyyaEW9uV";

export const globalProgramTypeNormal = "0";
export const globalProgramTypeTwoWeekSame = "1";

export const globalTimeExercise = 1;
export const globalSetsExercise = 2;
export const globalCircuitExercise = 3; //Time based
export const globalCompoundSetExercise = 4;
export const globalSuperSetExercise = 5;
export const globalTimeSetExercise = 6; //Time Exercise but with more than one set
export const globalCircuitExerciseRepsBased = 7;

export const globalExerciseSourceLocal = 0;
export const globalExerciseSourceFirestore = 1;

export function removeItemAll(arr, value) {
    let i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}

export function cleanString(input) {
    // takes a string as input and removes [, ], and "
    // input: ["INCLINE BENCH", "CHAIR"]
    //output: INCLINE BENCH, CHAIR
    // return str.replace(/[[\]"]/g, "");
    if (Array.isArray(input)) {
        return input.join(", ");
    }
    if (typeof input === "string") {
        return input.replace(/[[\]"]/g, "");
    }
    return "";
}

// export const globalProgramTypeNormalEmptyJson = {p:
//         [//3 phases:
//             {ph:[//4 weeks:
//                     {wk:[//5 days:
//                             {},{},{},{},{}
//                         ]},
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]}
//                 ]},
//             {ph:[
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]}
//                 ]},
//             {ph:[
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]},
//                     {wk:[{},{},{},{},{}]}
//                 ]}
//         ]
// };

export const globalProgramTypeNormalEmptyJson = {p:
        [//3 phases:
            {ph:[//4 weeks:
                    {wk:[//5 days:
                            {},{},{},{},{}
                        ]}
                ]}
        ]
};

export const globalProgramTypeTwoWeekSameEmptyJson = {p:
        [//3 phases:
            {ph:[//2 weeks:
                    {wk:[//5 days:
                            {},{},{},{},{}
                        ]},
                    {wk:[{},{},{},{},{}]}
                ]},
            {ph:[
                    {wk:[{},{},{},{},{}]},
                    {wk:[{},{},{},{},{}]}
                ]},
            {ph:[
                    {wk:[{},{},{},{},{}]},
                    {wk:[{},{},{},{},{}]}
                ]}
        ]
};

// Equipment, Muscle Group, Extra Equipment Master Lists (id <-> name)
export const equipmentList = [
    { id: 0, name: "Bodyweight" }, { id: 1, name: "Dumbbell" }, { id: 2, name: "Barbell" },
    { id: 3, name: "Resistance Band" }, { id: 4, name: "Kettlebell" }, { id: 5, name: "Cable" },
    { id: 6, name: "Medicine Ball" }, { id: 7, name: "Machine" }
];
export const muscleGroupList = [
    { id: 0, name: "Chest" }, { id: 1, name: "Back" }, { id: 2, name: "Traps" }, { id: 3, name: "Shoulders" },
    { id: 4, name: "Triceps" }, { id: 5, name: "Biceps" }, { id: 6, name: "Forearms" }, { id: 7, name: "Legs" },
    { id: 8, name: "Calves" }, { id: 9, name: "Glutes/Hips" }, { id: 10, name: "Lower Abs" },
    { id: 11, name: "Middle Abs" }, { id: 12, name: "Upper Abs" }, { id: 13, name: "Obliques" },
    { id: 14, name: "Cardio" }, { id: 15, name: "Upper Body" }, { id: 16, name: "Lower Body" }, { id: 18, name: "Low Impact Cardio" }
];
export const extraEquipmentList = [
    { id: 0, name: "Flat Bench" }, { id: 1, name: "Incline Bench" }, { id: 2, name: "Decline Bench" }, { id: 3, name: "Chair" },
    { id: 4, name: "Pull Up Bar" }, { id: 5, name: "Jump Rope" }, { id: 6, name: "Dip Attachment" }, { id: 7, name: "Roman Chair" },
    { id: 8, name: "Plyo Box" }, { id: 9, name: "Towel" }, { id: 10, name: "Partner" }, { id: 11, name: "Ab Roller Wheel" }, { id: 12, name: "Preacher Curl Bench" }
];

// Helper functions
export function idToName(list, id) {
    const found = list.find(e => e.id === id);
    return found ? found.name : id;
}

export function nameToId(list, name) {
    const found = list.find(e => e.name === name);
    return found ? found.id : name;
}
